import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonPublishedEventsCrumbs } from '../constants';
import { HttpResponse, HttpResponseList } from 'shell/models/http-response';
import FormPublishedEvent from 'system/components/published-events/form-published-event';
import {
  transformPublishedEvent,
  transformPublishedEventResponse,
} from '../utils/transform-publised-event';
import { PublishedEvent } from 'shell/models/pubblished-event';
import { ConsumedEvent } from 'shell/models/consumed-event';
import {
  ConsumedEventsResponse,
  transformConsumedEvents,
} from '../utils/transform-consumed-events';
import { Order } from 'shell/view-models/order';

export interface FormPublisedInitialValuesType extends transformPublishedEventResponse {
  rowsPerPage?: number;
  page: number;
  orders: Order;
}
const PublishedEventDetailPage = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  const [publishedEvent] = useHttpFetch<
    HttpResponse<PublishedEvent>,
    transformPublishedEventResponse
  >(`${__OPERATION__EVENT__ADMIN__}/eventoPubblicato/${params.id}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformPublishedEvent,
  });

  const [eventsConsumed, getConsumedEvents] = useHttpFetch<
    HttpResponseList<ConsumedEvent>,
    ConsumedEventsResponse
  >(`${__OPERATION__EVENT__ADMIN__}/eventoConsumato/list`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformConsumedEvents,
  });

  useEffect(() => {
    getConsumedEvents({
      url: `?idEventoPubblicato=${params.id}`,
    });
  }, []);

  const data: FormPublisedInitialValuesType = useMemo(() => {
    const convertedData = {
      ...((publishedEvent.data as transformPublishedEventResponse) || {}),
      rowsPerPage: 10,
      orders: {},
      page: (eventsConsumed.data as ConsumedEventsResponse)?.pageInfo?.page || 0,
    };
    return convertedData;
  }, [params, navigate, publishedEvent, eventsConsumed.data]);

  const isLoading =
    publishedEvent.isLoading ||
    publishedEvent.hasErrors ||
    publishedEvent.pristine ||
    eventsConsumed.isLoading ||
    eventsConsumed.hasErrors ||
    eventsConsumed.pristine;

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonPublishedEventsCrumbs, { name: 'Dettaglio Evento Pubblicato' }]}
      />
      {!isLoading ? (
        <FormPublishedEvent
          title="Dettaglio Evento Pubblicato"
          initialValues={data as FormPublisedInitialValuesType}
          onOk={onSubmit}
          disabled
          onCancel={() => {
            navigate('/sistema/eventmanager/ricerca-eventi-pubblicati');
          }}
        />
      ) : undefined}
    </Fragment>
  );
};

PublishedEventDetailPage.displayName = 'Published Event Page Detail component';

export default PublishedEventDetailPage;
